
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Avatar, Box, Chip, Tooltip, Typography } from "@mui/material";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import JumboScrollbar from "@jumbo/components/JumboScrollbar";
import { getMeetingUsers, getMemberVoteSummary, getUserFullName, sortByProperty } from "app/utils/appHelpers";
import config, { greenColor, redColor } from "config";

function PreviewMeetingUsersCard({ meeting, meetingUsers, votes, decisions }) {

    const [members, setMembers] = useState([]);
    const [participants, setParticipants] = useState([]);
    const userList = useSelector((state) => state.user.data);

    useEffect(() => {
        const fetchParticipants = async () => {
            try {
                const meetingUsersParticipants = await getMeetingUsers(meeting.id, userList, meetingUsers);

                if (meetingUsersParticipants && meetingUsersParticipants.length > 0) {
                    let memberList = sortByProperty(meetingUsersParticipants.filter(user => user.type === 1), "indexNo")
                    let participantList = sortByProperty(meetingUsersParticipants.filter(user => user.type === 2), "indexNo")

                    if (meeting.statVote === 1 || meeting.statFinish === 1) {
                        const voteList = votes || [];
                        const decisionList = decisions || [];
                        memberList = memberList.map(m => ({
                            ...m,
                            voteSummary: getMemberVoteSummary(m.userId, voteList, decisionList)
                        }));
                    }

                    setMembers(memberList);
                    setParticipants(participantList);
                }
            } catch (error) {
                console.error("Error fetching meeting participants:", error);
            }
        };

        if (meeting && meeting.id) {
            fetchParticipants();
        }
    }, [meeting, userList, meetingUsers, votes, decisions]);

    return (
        <JumboCardQuick
            title={
                <Typography sx={{ lineHeight: 1 }}>
                    Toplantının Üye ve Katılımcıları
                </Typography>
            }
            headerSx={{ borderBottom: 1, borderBottomColor: "divider" }}
            wrapperSx={{ p: 0 }}
        >

            <Box sx={{ p: 2 }}>
                <Box sx={{ display: "flex", gap: 2 }}>
                    <Box sx={{ flex: 1 }}>
                        <Typography sx={{ mb: 1, lineHeight: 1 }}>
                            <Chip label={`${members.length} Üye`} color="primary" size="small" />
                        </Typography>
                        {members.length === 0 ? (
                            <Typography variant="body2" sx={{ lineHeight: 1 }}>
                                Üye bulunamadı.
                            </Typography>
                        ) : (
                            members.map((member) => (
                                <Box
                                    key={member.userId}
                                    sx={{

                                        borderBottom: "1px solid #f0f0f0",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                    }}
                                >
                                    <Avatar
                                        alt={member.user ? member.user.name : ""}
                                        src={
                                            member.user && member.user.profileImageUrl
                                                ? `${config.userAuthApiUrl}${member.user.profileImageUrl}`
                                                : undefined
                                        }
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src =
                                                config.userAuthApiUrl + config.defaultProfileImageUrl;
                                        }}
                                    />
                                    <Typography variant="body2" sx={{ lineHeight: 1 }}>
                                        {getUserFullName(member.user)} ({member.inst})

                                        {member.memberRole === "Başkan" || member.memberRole === "Başkan Yrd" ? (
                                            <span style={{ fontStyle: "italic" }}>{" "}  ({member.memberRole})</span>
                                        ) : null}

                                        {member.acting === "Vekaleten" ? (
                                            <span style={{ fontStyle: "italic" }}>{" "}  (V.)</span>
                                        ) : null}

                                        {member.attendanceStatus === 0 || member.attendanceStatus === '0' ? (
                                            <span style={{ fontStyle: "italic" }}>{" "}  ({"Katılmadı"})</span>
                                        ) : member.voteSummary && member.voteSummary.decisionCount > 0 ? (
                                            <Tooltip
                                                title={
                                                    <span>
                                                        Karar sayısı: {member.voteSummary.decisionCount}<br />
                                                        Kabul: {member.voteSummary.acceptCount}<br />
                                                        Ret: {member.voteSummary.rejectCount}<br />
                                                        Kullanılmayan: {member.voteSummary.unvotedCount}
                                                    </span>
                                                }
                                            >
                                                <span style={{
                                                    marginLeft: 4,
                                                    color: member.voteSummary.usedCount === 0
                                                        ? redColor
                                                        : member.voteSummary.usedCount === member.voteSummary.decisionCount
                                                            ? greenColor
                                                            : "gray"
                                                }}>
                                                    {member.voteSummary.usedCount}/{member.voteSummary.decisionCount}
                                                </span>
                                            </Tooltip>
                                        ) : null}
                                    </Typography>
                                </Box>
                            ))
                        )}
                    </Box>

                    <Box sx={{ flex: 1 }}>
                        <Typography sx={{ mb: 1, lineHeight: 1 }}>
                            <Chip label={`${participants.length} Katılımcı`} color="primary" size="small" />
                        </Typography>
                        {participants.length === 0 ? (
                            <Typography variant="body2" sx={{ lineHeight: 1 }}>
                                Katılımcı bulunamadı.
                            </Typography>
                        ) : (
                            participants.map((participant) => (
                                <Box
                                    key={participant.userId}
                                    sx={{

                                        borderBottom: "1px solid #f0f0f0",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                    }}
                                >
                                    <Avatar
                                        alt={participant.user ? participant.user.name : ""}
                                        src={
                                            participant.user && participant.user.profileImageUrl
                                                ? `${config.userAuthApiUrl}${participant.user.profileImageUrl}`
                                                : undefined
                                        }
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src =
                                                config.userAuthApiUrl + config.defaultProfileImageUrl;
                                        }}
                                    />
                                    <Typography variant="body2" sx={{ lineHeight: 1 }}>
                                        {getUserFullName(participant.user)}
                                    </Typography>
                                </Box>
                            ))
                        )}
                    </Box>
                </Box>
            </Box>
        </JumboCardQuick>
    );
}

export default PreviewMeetingUsersCard;